import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator(
  'large_group_custom_benefits_set', '/large_group_custom_benefits_sets', 'benefits_set'
)
const actions = generator.generate()

export default actions
